import { render, staticRenderFns } from "./AuthenLayout.vue?vue&type=template&id=6ffbd891&scoped=true&"
import script from "./AuthenLayout.vue?vue&type=script&lang=js&"
export * from "./AuthenLayout.vue?vue&type=script&lang=js&"
import style0 from "./AuthenLayout.vue?vue&type=style&index=0&id=6ffbd891&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffbd891",
  null
  
)

export default component.exports